
import React from 'react';
import PropTypes from 'prop-types';
import { StyledRow } from '../styled';

export const Row = React.memo(({ children, className }) => (
  <StyledRow className={className}>{children}</StyledRow>
));

Row.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  className: PropTypes.string
};
Row.defaultProps = {
  className: undefined
};

export default Row;
